import { FaBarsStaggered } from "react-icons/fa6";
import classes from "./Header.module.css";
import { FaHouse, FaFutbol, FaTrophy, FaClock } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../store/slices/languageSlice";
import { useEffect } from "react";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";

const Header = ({ active, hide }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedLanguage } = useSelector(state => state.languageSlice);

    const {t}=useTranslation();

    useEffect(() => {
        if (selectedLanguage && i18n.language != selectedLanguage) {
            i18n.changeLanguage(selectedLanguage);
        }
    }, [selectedLanguage, i18n]);

    return (
        <div className={classes.header}>
            <div className={classes.header_nav}>
                <div className={classes.logo_container}>
                    <img src="assets/images/logo.png" alt="UVFootball XI" className={classes.logo} />
                </div>


                <select id="lang" name="lang" className={classes.dropdown}
                    value={selectedLanguage}
                    onChange={(event) => {
                        dispatch(setLanguage(event.target.value));
                    }}
                >
                    <option value="0">English</option>
                    <option value="1">
                        French
                    </option>
                </select>

            </div>

            {!hide && <>
                <div className={classes.top_menu_items_container}>
                    <div className={classes.top_navbar_item}
                        onClick={() => {
                            navigate("/home")
                        }}
                    >
                        <FaHouse className={`${classes.top_navbar_icon} ${active == 0 && classes.active}`} />
                        <p className={`${classes.top_navbar_item_name} ${active == 0 && classes.active}`}>{t("142")}</p>
                    </div>

                    <div className={classes.top_navbar_item}
                        onClick={() => {
                            navigate("/my-matches")
                        }}
                    >
                        <FaFutbol className={`${classes.top_navbar_icon} ${active == 1 && classes.active}`} />
                        <p className={`${classes.top_navbar_item_name} ${active == 1 && classes.active}`}>{t("143")}</p>
                    </div>

                    <div className={classes.top_navbar_item}
                        onClick={() => {
                            navigate("/live")
                        }}
                    >
                        <FaClock className={`${classes.top_navbar_icon} ${active == 2 && classes.active}`} />
                        <p className={`${classes.top_navbar_item_name} ${active == 2 && classes.active}`}>{t("144")}</p>
                    </div>

                    <div className={classes.top_navbar_item}
                        onClick={() => {
                            navigate("/leaderboard")
                        }}
                    >
                        <FaTrophy className={`${classes.top_navbar_icon} ${active == 3 && classes.active}`} />
                        <p className={`${classes.top_navbar_item_name} ${active == 3 && classes.active}`}>{t("145")}</p>
                    </div>

                    <div className={classes.top_navbar_item}
                        onClick={() => {
                            navigate("/profile")
                        }}
                    >
                        <FaUser className={`${classes.top_navbar_icon} ${active == 4 && classes.active}`} />
                        <p className={`${classes.top_navbar_item_name} ${active == 4 && classes.active}`}>{t("146")}</p>
                    </div>

                </div>
            </>}


        </div>
    )
}

export default Header